var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSidebarBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.25C4.272 1.25 1.25 4.272 1.25 8C1.25 11.728 4.272 14.75 8 14.75C11.728 14.75 14.75 11.728 14.75 8C14.75 4.272 11.728 1.25 8 1.25ZM8 2.6C10.982 2.6 13.4 5.018 13.4 8C13.4 10.982 10.982 13.4 8 13.4C5.018 13.4 2.6 10.982 2.6 8C2.6 5.018 5.018 2.6 8 2.6ZM7.05 3.85H8.15V4.7H8.55C9.62 4.7 10.35 5.24 10.35 6.08C10.35 6.62 9.98 7.06 9.42 7.26C10.08 7.46 10.5 7.96 10.5 8.58C10.5 9.52 9.68 10.12 8.45 10.12H8.15V11.05H7.05V10.12H6.25V9.12H7.05V6.78H6.25V5.78H7.05V3.85ZM8.15 5.7V7.15H8.62C9.12 7.15 9.42 6.92 9.42 6.54C9.42 6.16 9.1 5.92 8.58 5.92H8.15V5.7ZM8.15 8.05V9.22H8.72C9.32 9.22 9.62 8.96 9.62 8.52C9.62 8.08 9.28 7.82 8.68 7.82H8.15V8.05Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBitcoin);
export default __webpack_public_path__ + "static/media/sidebar-bitcoin.53711082d794fa5d4501ef7836c83828.svg";
export { ForwardRef as ReactComponent };